import i18n from "i18next";
import { initReactI18next } from "react-i18next";
// Always load Polish first - English loaded on demand
import pl from "./locales/pl.json";

// Check if user has previously selected a language or if URL indicates English
const getInitialLanguage = () => {
  try {
    // Check if we're on /en path (for SSR or initial load)
    if (typeof window !== 'undefined' && window.location.pathname.startsWith('/en')) {
      return 'en';
    }
    // Check localStorage
    const savedLang = localStorage.getItem("i18nextLng");
    if (savedLang && (savedLang === "pl" || savedLang === "en")) {
      return savedLang;
    }
  } catch {
    // Ignore errors
  }
  return "pl"; // Default to Polish
};

const initialLang = getInitialLanguage();

// Always start with Polish loaded - English will be lazy loaded if needed
const resources = {
  pl: { translation: pl },
};

// Initialize with detected language
i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    lng: initialLang, // Use detected language
    fallbackLng: "pl",
    keySeparator: false, // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

// Lazy load English if initial language is English
if (initialLang === "en") {
  import("./locales/en.json")
    .then((en) => {
      resources.en = { translation: en.default || en };
      i18n.addResourceBundle("en", "translation", en.default || en);
      // Language is already set to "en" from init
    })
    .catch(() => {
      console.warn("Failed to load English translations, falling back to Polish");
      i18n.changeLanguage("pl");
    });
}

// Lazy load English when user switches to it (or when navigating to /en)
i18n.on("languageChanged", (lng) => {
  if (lng === "en" && !resources.en) {
    import("./locales/en.json")
      .then((en) => {
        resources.en = { translation: en.default || en };
        i18n.addResourceBundle("en", "translation", en.default || en);
      })
      .catch(() => {
        console.warn("Failed to lazy load English translations");
        i18n.changeLanguage("pl"); // Fallback to Polish
      });
  }
});

export default i18n; 